import { NotifyHelper } from "../../../helpers/toast";
import { eTsLePhiBuocNhayActionsObj } from "../../action-types/category/ITsLePhiBuocNhayActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const lePhiBuocNhayActions = {
  ...generateActions(eTsLePhiBuocNhayActionsObj, "LE_PHI_BUOC_NHAY"),
  ...generateActionForKey(
    eTsLePhiBuocNhayActionsObj,
    "LE_PHI_BUOC_NHAY",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã lưu bước nhảy lệ phí");
    }
  ),
  ...generateActionForKey(
    eTsLePhiBuocNhayActionsObj,
    "LE_PHI_BUOC_NHAY",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m ?? "Lưu thất bại");
    }
  ),
};
